import React, { useState, useEffect, useRef } from "react";
import CountUp from "react-countup";
import { FaArrowRight } from "react-icons/fa";

const Mission = () => {
  const [startCount, setStartCount] = useState(false);
  const sectionRef = useRef(null);

  // Intersection observer to trigger counting when in view
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStartCount(true);
          observer.disconnect();
        }
      },
      { threshold: 0.5 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="py-20 px-6 bg-white max-w-7xl mx-auto space-y-12"
    >
      {/* Header */}
      <div className="text-center">
        <p className="text-teal-500 font-semibold uppercase tracking-wide mb-2">
          Our Mission
        </p>
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 max-w-4xl mx-auto">
          We have helped innovative companies accelerate growth
        </h2>
        <p className="text-gray-600 max-w-3xl mx-auto mt-4">
          Supporting hundreds of businesses of all sizes and across various
          industries.
        </p>
      </div>
      {/* Stats */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-10 max-w-5xl mx-auto text-center">
        {/* Stat 1 */}
        <div>
          <h3 className="text-5xl font-extrabold text-teal-500 mb-2">
            {startCount ? <CountUp end={25} duration={2.5} /> : 0}%
          </h3>
          <p className="text-gray-700 font-semibold">Revenue Growth</p>
          <p className="text-gray-600 text-sm mt-1">
            Achieved by our clients on average annually.
          </p>
        </div>

        {/* Stat 2 */}
        <div>
          <h3 className="text-5xl font-extrabold text-teal-500 mb-2">
            {startCount ? <CountUp end={150} duration={2.5} /> : 0}k
          </h3>
          <p className="text-gray-700 font-semibold">Annual Revenue</p>
          <p className="text-gray-600 text-sm mt-1">
            Generated by businesses using our platform.
          </p>
        </div>

        {/* Stat 3 */}
        <div>
          <h3 className="text-5xl font-extrabold text-teal-500 mb-2">
            {startCount ? <CountUp end={14} duration={2.5} /> : 0}+
          </h3>
          <p className="text-gray-700 font-semibold">Months of Runway</p>
          <p className="text-gray-600 text-sm mt-1">
            Average runway businesses sustain with our support.
          </p>
        </div>
      </div>
      {/* Pricing Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12">
        {/* Plus Plan */}
        <a
          href="#"
          className="group border border-gray-300 rounded-lg p-12 flex flex-col justify-between relative hover:bg-teal-50 transition h-72"
        >
          <FaArrowRight
            className="absolute bottom-6 right-6 text-teal-500 text-5xl -rotate-45 group-hover:rotate-0 transition-transform duration-300"
            aria-hidden="true"
          />
          <h3 className="text-3xl font-semibold mb-4 text-teal-500">
            Plus Plan
          </h3>
          <p className="text-xl font-semibold text-gray-700">$3.99 / month</p>
        </a>

        {/* Premium Plan */}
        <a
          href="#"
          className="group bg-teal-500 rounded-lg p-12 flex flex-col justify-between relative hover:bg-teal-600 transition text-white h-72"
        >
          <FaArrowRight
            className="absolute bottom-6 right-6 text-white text-5xl -rotate-45 group-hover:rotate-0 transition-transform duration-300"
            aria-hidden="true"
          />
          <h3 className="text-3xl font-semibold mb-4">Premium Plan</h3>
          <p className="text-xl font-semibold">$9.99 / month</p>
        </a>
      </div>
    </section>
  );
};

export default Mission;
